import React from 'react'
import './Footer.css'

function Footer() {
    return (
        <div>
            <footer>
                <div className="social_media">
                    <i className="fab fa-facebook"></i>
                    <i className="fab fa-twitter"></i>
                    <i className="fab fa-youtube"></i>
                </div>
                <p>Copyright@2021<span>Atelier solidaire-DevSolution</span></p>
            </footer>
        </div>
    )
}

export default Footer
